import React, { useEffect, useState } from "react";
import { ArrowRight, Sparkles } from "lucide-react";

const HIDE_THRESHOLD = 200; // px scrolled prima di mostrare

/**
 * Sticky CTA visibile SOLO su mobile (lg:hidden).
 * Appare dopo aver scrollato la hero (200px), si nasconde vicino al footer
 * per non coprire i CTA di contatto.
 */
export default function StickyMobileCTA() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY;
      const nearBottom =
        window.innerHeight + y >= document.documentElement.scrollHeight - 400;
      setVisible(y > HIDE_THRESHOLD && !nearBottom);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      data-testid="sticky-mobile-cta"
      aria-hidden={!visible}
      className={`lg:hidden fixed bottom-0 left-0 right-0 z-40 transition-all duration-300 ${
        visible
          ? "translate-y-0 opacity-100 pointer-events-auto"
          : "translate-y-full opacity-0 pointer-events-none"
      }`}
    >
      <div className="mx-3 mb-3 rounded-2xl shadow-2xl bg-gradient-to-r from-[#0a1f55] via-[#102a6b] to-[#1e3a8a] border border-[#f59e0b]/30 overflow-hidden">
        <a
          href="/#pacchetti"
          data-testid="sticky-mobile-cta-link"
          className="flex items-center gap-3 p-3.5"
        >
          <div className="h-11 w-11 rounded-xl bg-[#f59e0b] text-[#0a1f55] flex items-center justify-center flex-shrink-0">
            <Sparkles className="h-5 w-5" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="text-[10.5px] font-extrabold uppercase tracking-[0.2em] text-[#fbbf24]">
              Offerta 2 mesi
            </div>
            <div className="text-white font-extrabold text-[15px] leading-tight">
              Da <span className="text-[#fbbf24]">€ 99</span> · Iscriviti ora
            </div>
          </div>
          <div className="flex-shrink-0 h-10 w-10 rounded-full bg-[#f59e0b] hover:bg-[#d97706] text-[#0a1f55] flex items-center justify-center shadow-lg">
            <ArrowRight className="h-5 w-5" />
          </div>
        </a>
      </div>
    </div>
  );
}
